export default "__VITE_ASSET__BKwOH413__"